import { getAllGuaranteesSuccess, startLoading } from 'redux/slices/all-guarantees'

const fetchAndDispatch = (QueryContractResponse, dispatch) => {
  const guaranteesReceived = QueryContractResponse?.entries
  console.log('>>>>Guarantees Received', guaranteesReceived)
  dispatch(startLoading())
  dispatch(getAllGuaranteesSuccess(guaranteesReceived))
}

export default fetchAndDispatch
